import React from 'react';
import { TableRow, TableCell, TableBody } from '@one-thd/sui-atomic-components';
import { Checkmark } from '@one-thd/sui-icons';
import { TableHeader } from './table-header';
export var PerksTableContent = function (_a) {
    var isEnrolled = _a.isEnrolled;
    return (React.createElement(React.Fragment, null,
        React.createElement(TableHeader, { title: "Perks", showRunner: isEnrolled }),
        React.createElement(TableBody, null,
            React.createElement(TableRow, null,
                React.createElement(TableCell, { width: "full", sticky: "horizontal" }, "Manage perks"),
                React.createElement(TableCell, { align: "center", width: "full " },
                    React.createElement(Checkmark, null)),
                React.createElement(TableCell, { width: "full" }),
                isEnrolled && React.createElement(TableCell, { width: "full" })))));
};
